import { T } from "@tolgee/react";
import {
  CheckCrpQuantitiesCloseButton,
  NavigateToCrp1QuestionnaireButton,
} from "../atoms";
import { Close } from "../ui/dialog";

const CheckCrpQuantitiesContent = () => {
  return (
    <div className="flex flex-col gap-5 items-center text-gray-900 text-xs font-normal leading-[18px] overflow-auto">
      <div className="flex flex-col text-center">
        <span>
          <T keyName="check-crp-quantities-dialog-content-title" />
        </span>
        <span className="font-semibold">
          <T keyName="check-crp-quantities-dialog-content-bold-title" />
        </span>
      </div>
      <div className="p-5 bg-white rounded-lg w-[222px]">
        <div className="flex flex-row gap-2.5 items-center">
          <img
            src="/images/check-quantities-dialog-progress-bar.svg"
            alt="check-crp-quantities-dialog-content-image"
            height={70}
            width={10}
          />
          <div className="flex flex-col justify-between gap-2.5 text-sm">
            <span>
              <T keyName="check-crp-quantities-dialog-content-progress-bar-step-1" />
            </span>
            <span>
              <T keyName="check-crp-quantities-dialog-content-progress-bar-step-2" />
            </span>
            <span>
              <T keyName="check-crp-quantities-dialog-content-progress-bar-step-3" />
            </span>
          </div>
        </div>
      </div>
      <div className="flex justify-center gap-2.5">
        <NavigateToCrp1QuestionnaireButton />
        <Close asChild>
          <CheckCrpQuantitiesCloseButton />
        </Close>
      </div>
      <div className="flex flex-col text-center text-xxs">
        <span>
          <T keyName="check-crp-quantities-dialog-content-bottom-text-1" />
        </span>
        <span>
          <T keyName="check-crp-quantities-dialog-content-bottom-text-2" />
        </span>
      </div>
    </div>
  );
};

export { CheckCrpQuantitiesContent };
